import {
  Box,
  Typography,
  CircularProgress,
  Snackbar,
  Alert,
} from "@mui/material";
import { FormProvider, useForm } from "react-hook-form";
import { format } from "date-fns";
import { useLoaderData } from "react-router-dom";
import { useState } from "react";

import { CellType } from "../../types/CellTypes";
import { CellForm } from "../../components/common/form/CellForm";
import { DynamicTable, TableColumn } from "../../components/common/table/Table";
import { OperatorDropdown } from "../../components/ui/dropdown/Operator";

export default function CellPage() {
  const methods = useForm();
  const { cells } = useLoaderData() as { cells: CellType[] };

  const [operatorId, setOperatorId] = useState<number>(0);
  const [showSuccess, setShowSuccess] = useState(false);

  return (
    <Box p={4}>
      <Box display="flex" flexDirection="row" gap={4} alignItems="flex-start">
        {/* Form Side */}
        <Box flex={1}>
          <Typography variant="h6" gutterBottom>
            Neue Zelle erfassen
          </Typography>

          <Box mb={2}>
            <OperatorDropdown value={operatorId} onChange={setOperatorId} />
          </Box>

          <FormProvider {...methods}>
            <CellForm
              operatorId={operatorId}
              onSuccess={() => setShowSuccess(true)}
            />
          </FormProvider>
        </Box>

        {/* Table Side */}
        <Box flex={3}>
          <Typography variant="h6" gutterBottom>
            Letzte Zellen-Einträge
          </Typography>

          {cells.length === 0 ? (
            <CircularProgress />
          ) : (
            <DynamicTable columns={columns} data={cells} />
          )}
        </Box>
      </Box>

      <Snackbar
        open={showSuccess}
        autoHideDuration={6000}
        onClose={() => setShowSuccess(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setShowSuccess(false)}
          severity="success"
          sx={{ width: "100%" }}
        >
          Zelle erfolgreich gespeichert!
        </Alert>
      </Snackbar>
    </Box>
  );
}

const columns: TableColumn<CellType>[] = [
  {
    key: "dateinproduction",
    label: "Produktionsdatum",
    render: (value) =>
      value ? format(new Date(value as string), "yyyy-MM-dd HH:mm:ss") : "-",
  },
  {
    key: "cellbatch",
    label: "Batch Nr.",
    render: (value) => value || "-",
  },
  {
    key: "firstname",
    label: "Operator",
    render: (_, row) =>
      row.firstname && row.lastname ? `${row.firstname} ${row.lastname}` : "-",
  },
];
